<template>
  <UserDashboard />
</template>

<script>
import UserDashboard from "@/components/Ondemand/Dashboard/Dashboard.vue";
export default {
  components: {
    UserDashboard,
  },
  computed: {
    userType() {
      return this.$store.getters.userType;
    },
  },
  methods: {
    addTwakTo() {
      // Avoid loading twice
      if (document.getElementById("tawk-script")) return;

      const s1 = document.createElement("script");
      s1.id = "tawk-script";
      s1.async = true;
      s1.src = "https://embed.tawk.to/68f21cfd3971cd194f4da742/1j7os2fsd";
      s1.charset = "UTF-8";
      s1.setAttribute("crossorigin", "*");
      document.body.appendChild(s1);
    }
  },
  mounted() {
    let userType = this.$store.getters.userType;
    if (userType != "ondemand") {
      this.$router.push("/3pl/dashboard");
    }
    this.addTwakTo();
    this.$_removeTwakTo('display: block !important');
  },
  beforeDestroy() {
    this.$_removeTwakTo('display: none !important');
  }
};
</script>

<style></style>
